import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import RefundService from '@services/refund'

export const getAllPendingRefunds = createAsyncThunk('refund/getAllPendingRefunds', async (params, { rejectWithValue }) => {
  try {
    const response = await RefundService.getAllPendingRefunds(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getAllRefundedList = createAsyncThunk('refund/getAllRefundedList', async (params, { rejectWithValue }) => {
  try {
    const response = await RefundService.getAllRefundedList(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const createRefund = createAsyncThunk('refund/createRefund', async (data, { rejectWithValue }) => {
  try {
    const response = await RefundService.createRefund(data)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

const refundSlice = createSlice({
  name: 'refund',
  initialState: {
    data: [],
    total: 1,
    params: {},
    loading: false,
    error: null
  },
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(getAllPendingRefunds.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = false
      })
      .addCase(getAllPendingRefunds.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllPendingRefunds.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getAllRefundedList.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = false
      })
      .addCase(getAllRefundedList.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllRefundedList.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(createRefund.fulfilled, (state) => {
        state.loading = false
      })
  }
})

export default refundSlice.reducer
